import React from 'react';
import { Stack, Text } from '@moda/om';

import './DesktopNavigationV2EditorialColumnText.scss';

export const DesktopNavigationV2EditorialColumnText: React.FC<{ text: string | null }> = ({
  text
}) => (
  <Stack alignItems="center" className="DesktopNavigationV2EditorialColumnText" space={0}>
    <Text family="serif" treatment="h6">
      {text}
    </Text>
  </Stack>
);
